import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import useAutoScroll from "../../../hooks/useAutoScroll";

const ThreeExperiences = () => {
  const { t } = useTranslation();
  const gridRef = useAutoScroll(10000);

  const experiences = [
    {
      key: "connect",
      title: t("ourServices.cards.connect.title"),
      desc: t("ourServices.cards.connect.body"),
      btnColor: "blue",
      link: "/sulhafa-connect",
    },
    {
      key: "care",
      title: t("ourServices.cards.care.title"),
      desc: t("ourServices.cards.care.body"),
      btnColor: "teal",
      link: "/sulhafa-care",
    },
    {
      key: "shop",
      title: t("ourServices.cards.shop.title"),
      desc: t("ourServices.cards.shop.body"),
      btnColor: "orange",
      link: "/about/sulhafa-shop",
    },
  ];

  return (
    <section className="landing-experiences">
      <h2 className="landing-section-title">{t("ourServices.title")}</h2>
      <p className="landing-section-subtitle">{t("ourServices.subtitle")}</p>
      <div className="landing-experiences-grid" ref={gridRef}>
        {experiences.map((exp) => (
          <div key={exp.key} className={`landing-experience-card ${exp.key}`}>
            <div className="landing-card-image">
              <img
                src={`/Landing page assets/${exp.key === "connect" ? "chat" : exp.key === "care" ? "vet" : "shopping"}.png`}
                alt={exp.title}
              />
            </div>
            <h3>{exp.title}</h3>
            <p>{exp.desc}</p>
            {exp.link ? (
              <Link to={exp.link} className={`landing-btn ${exp.btnColor}`}>
                {t("ourServices.cards.more")}
              </Link>
            ) : (
              <button className={`landing-btn ${exp.btnColor}`} disabled>
                {t("ourServices.cards.more")}
              </button>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default ThreeExperiences;
